import { render, staticRenderFns } from "./dataProductDesign.vue?vue&type=template&id=2017f9bc&scoped=true"
import script from "./dataProductDesign.vue?vue&type=script&lang=js"
export * from "./dataProductDesign.vue?vue&type=script&lang=js"
import style0 from "./dataProductDesign.vue?vue&type=style&index=0&id=2017f9bc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2017f9bc",
  null
  
)

export default component.exports